'use strict';

$(function () {
  var homeHeroElem = $(document).find('[data-home-hero-full]');

  if (homeHeroElem.length) {
    var textColour = homeHeroElem.attr('data-text-colour');
    var headerOverBanner = homeHeroElem.attr('data-header-over-banner') == 'true';
    if (headerOverBanner) {
      document.body.classList.add('has-header-text-colour-' + textColour);
    } else {
      document.body.classList.add('is-not-over-full-banner');
    }
  }
});